"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return 1900;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-impression-tracking/build/maxChunkSize.js
 ** module id = 47
 ** module chunks = 0
 **/